<template>
  <div class="my-box van-hairline--bottom" @click="click">
    <div class="my-text">
      <div class="text">{{ tilde }}</div>
      <div>
        <div class="my-sub-txt">信息来源：{{ subTilde }}</div>
        <div class="my-sub-txt" style="margin-top:.2rem">发布时间：{{ postDate }}</div>
      </div>
    </div>
    <!-- v-if="img !== '-'" -->
    <img v-if="img" :src="img" class="my-img" />
  </div>
</template>

<script>
import service from "../api/service";

export default {
  name: "homeCall",
  props: {
    tilde: "",
    subTilde: "",
    briefIntroduction: {
      type: String,
      default: "-",
    },
    postDate: {
      type: String,
      default: "-",
    },
    img: {
      type: String,
      default: "-",
    },
  },
  data() {
    return {
      baseURLB: service.baseURLB,
    };
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.my-box {
  width: 100%;
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.my-img {
  height: 5rem;
  width: 7rem;
  border-radius: 0.3rem;
  object-fit: contain;
  flex-shrink: 0;
}

.my-text {
  line-height: 1.4;
}

.text {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.my-sub-txt {
  margin-top: 0.7rem;
  font-size: 0.6rem;
  color: #a1a1a1;
}
</style>